import { API_URL } from "@/constants/constants";
import axios from "axios";


export default class ProductsProvider {

  static async getProductos() {
    let response = await axios.get(
       API_URL + "/api/products"
      );
    return response.data.data.products;
  }

  static async sincronizarProductos(){
    let response = await axios.get(API_URL + "/api/products/actualizar")
    return response.data
  }

   static async sincronizarProductosMayorista(){
    let response = await axios.get(API_URL + "/api/products/actualizarMayorista")
    return response.data
  }


  static async getProductosPDF(){
    window.open(`${API_URL}/api/productsPdf/lista_precios.pdf`, "_blank")
  }

  static async getProductosMayoristasPDF(){
    window.open(`${API_URL}/api/productsMayoristaPdf/lista_precios_mayorista.pdf`, "_blank")
  }

}
